import { Avatar, Style } from '@dicebear/core';
import definition from '@dicebear/styles/avataaars.json';

export const AVATAR_SIZE = 256;

const style = new Style(definition);

export const createBotAvatarSvg = (userId: string): string => {
  const avatar = new Avatar(style, {
    seed: userId,
    size: AVATAR_SIZE,
    backgroundColor: ['b6e3f4', 'c0aede', 'ffdfbf', 'ffd5dc', 'd1d4f9'],
    skinColor: ['f2d3b1', 'ae5d29', 'ecad80', 'f1d592', 'c68642', '8d5524'],
    hairColor: ['090806', '2c1b18', '8b4513', 'daa520', 'cd853f', 'a0522d'],
    clothesColor: ['ff6b6b', '4ecdc4', '45b7d1', '96ceb4', 'ffeaa7', 'dda0dd'],
    mouthVariant: ['smile', 'serious', 'tongue', 'twinkle'],
    eyesVariant: [
      'default',
      'happy',
      'wink',
      'closed',
      'cry',
      'eyeRoll',
      'hearts',
      'side',
      'squint',
      'surprised',
      'winkWacky',
      'xDizzy',
    ],
    eyebrowsVariant: [
      'default',
      'angry',
      'angryNatural',
      'defaultNatural',
      'flatNatural',
      'frownNatural',
      'raisedExcitedNatural',
      'sadConcernedNatural',
      'unibrowNatural',
      'upDownNatural',
      'raisedExcited',
      'sadConcerned',
      'upDown',
    ],
    accessoriesVariant: [
      'round',
      'wayfarers',
      'kurt',
      'prescription01',
      'prescription02',
      'sunglasses',
    ],
    accessoriesProbability: 30,
    clothesVariant: [
      'graphicShirt',
      'hoodie',
      'overall',
      'shirtCrewNeck',
      'shirtScoopNeck',
      'shirtVNeck',
      'blazerAndShirt',
      'blazerAndSweater',
      'collarAndSweater',
    ],
    clothesGraphicVariant: [
      'bat',
      'cumbia',
      'deer',
      'diamond',
      'hola',
      'pizza',
      'resist',
      'bear',
      'skullOutline',
      'skull',
    ],
  });

  return avatar.toString();
};

/**
 * Generate a bot avatar filename for a given user ID
 * @param userId - The bot's user ID
 * @returns Bot avatar filename (not full path)
 */
export const getBotAvatarFilename = (userId: string): string => {
  return `bot-${userId}.png`;
};

/**
 * Check if a filename is a bot avatar
 * @param filename - The filename to check
 * @returns True if it's a bot avatar filename
 */
export const isBotAvatarFilename = (filename: string): boolean => {
  return filename.startsWith('bot-') && filename.endsWith('.png');
};
